<template>
  <div
    class="st-headline"
    :class="{ 'st-headline--with-border': displayBorder }"
  >
    <component
      :is="headlineTag"
      class="st-headline__text"
      :class="`st-headline__text--${headlineTag}`"
    >
      {{ headlineText }}
    </component>
  </div>
</template>

<script>
export default {
  name: "st-headline",
  props: {
    headlineLevel: {
      type: Number,
      default: 1,
      validator(val) {
        return val > 0 && val < 7;
      },
    },
    headlineText: {
      type: String,
      default: "Default text",
    },
    displayBorder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headlineTag() {
      const headlineTagMap = {
        1: "h1",
        2: "h2",
        3: "h3",
        4: "h4",
        5: "h5",
        6: "h6",
      };
      return this.headlineLevel ? headlineTagMap[this.headlineLevel] : "h1";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-headline {
  &--with-border {
    padding-bottom: rem-calc(24);
    border-bottom: rem-calc(1) solid $grey;
  }
  &__text {
    font-weight: 700;
    margin: 0;
    &--h1 {
      font-size: rem-calc(36);
    }
    &--h2 {
      font-size: rem-calc(24);
    }
    &--h3 {
      font-size: rem-calc(18);
    }
    &--h4,
    &--h5,
    &--h6 {
      font-size: rem-calc(16);
    }
  }
}
</style>
